import { createSlice } from "@reduxjs/toolkit";

const initState = {
  WARD: {
    type: "WARD",
    available: "",
    occupied: "",
    total: "",
  },
  ICU: {
    type: "ICU",
    available: "",
    occupied: "",
    total: "",
  },
  available: "",
  occupied: "",
  total: "",
};

export const bedStatusSlice = createSlice({
  name: "bedStatus",
  initialState: initState,
  reducers: {
    setBedStatusEmpty: () => {
      return initState;
    },
    updateBed: (state, action) => {
      state.available = action.payload.available;
      state.occupied = action.payload.occupied;
      state.total = action.payload.total;
    },
    setWARDStatus: (state, action) => {
      const { payload } = action;
      state.WARD = {...state.WARD, ...payload};
    },
    setICUStatus: (state, action) => {
      const { payload } = action;
      state.ICU = {...state.ICU, ...payload};
    },
  },
});
